import { Path, Svg } from "@react-pdf/renderer";

import { tenant } from ".";

import type { DocumentTenant } from "@pego/payment-document-export";

// Mirrors ./assets/logo-primary.svg. The viewBox is not optional: without it
// react-pdf renders the vector clipped or blank.
const LOGO_VIEW_BOX = "0 0 70 27";
const LOGO_WIDTH = 81;
const LOGO_PATH =
  "M3.03 21.77c.36 0 .73-.02 1.14-.06V8.59c0-1.96-1.13-2.42-2.72-2.42-.36 0-.72.03-1.12.06V19c0 1.97 1.06 2.75 2.69 2.75v.01ZM0 2.25a2.28 2.28 0 0 0 2.25 2.28 2.26 2.26 0 0 0 0-4.53A2.26 2.26 0 0 0 0 2.25Zm6.93 16.78c0 1.96 1.05 2.74 2.68 2.74a12 12 0 0 0 1.15-.06v-8.78c0-2.43 1.24-3.66 2.96-3.66s2.96 1.11 2.96 3.54v6.22c0 1.96 1.06 2.74 2.69 2.74.36 0 .73-.02 1.14-.06v-8.35c0-2.18-.35-3.45-.95-4.48-1.17-2-3.31-3.04-5.85-3.04a6.7 6.7 0 0 0-5.42 2.5c-.86 1.13-1.38 2.66-1.38 5.2v5.51l.02-.01ZM23.27 24c0 1.96 1.05 2.74 2.68 2.74.36 0 .73-.02 1.14-.06v-7.02c.75 1.58 2.26 2.45 4.32 2.45 3.67 0 6.6-3.13 6.6-8.13 0-1.86-.4-3.53-1.32-4.97a6.77 6.77 0 0 0-5.98-3.16c-2.41 0-4.36.9-5.67 2.6-1.14 1.48-1.77 3.26-1.77 7v8.57V24Zm3.84-9.96c0-2.34.93-4.77 3.53-4.77 2.33 0 3.42 2.06 3.42 4.62 0 2.3-.9 4.77-3.44 4.77s-3.51-2.03-3.51-4.62Zm12.88.21c0 4.83 2.81 7.86 6.42 7.86 2.03 0 3.89-.9 4.7-2.6.15 1.59 1.05 2.27 2.53 2.27.34 0 .7-.02 1.09-.06v-6.28c0-3.74-.55-5.53-1.65-7-1.25-1.68-3.23-2.6-5.68-2.6-2.45 0-4.57.98-5.98 3.16a9.42 9.42 0 0 0-1.43 5.25Zm3.94-.2c0-2.3.94-4.78 3.5-4.78 2.55 0 3.46 2.03 3.47 4.57 0 2.48-.92 4.81-3.6 4.81-2.47 0-3.34-2.34-3.35-4.6h-.02ZM55.56 6.4 61 20.97c-.92 1.78-1.91 3.6-2.77 5.16l.28.24a3 3 0 0 0 2.08.63c1 0 1.8-.54 2.44-1.73 2.5-4.6 5.45-11.03 6.65-15.06.21-.71.33-1.34.33-1.91 0-1.25-.89-2.04-2.35-2.04-.3 0-.55 0-1.17.04a61.28 61.28 0 0 1-3.13 10.42c-1.2-3.47-2.48-7.32-2.95-8.51-.54-1.35-1.34-2.06-2.9-2.06a7.3 7.3 0 0 0-1.93.22v.02Z";

export const documentTenant: DocumentTenant = {
  id: tenant.id,
  legalName: tenant.identity.legalName,
  addressLines: tenant.identity.addressLines,
  website: tenant.identity.website,
  logo: (
    <Svg viewBox={LOGO_VIEW_BOX} style={{ width: LOGO_WIDTH }}>
      <Path d={LOGO_PATH} fill={tenant.colors.contentBrand} />
    </Svg>
  ),
  colors: {
    topBar: tenant.colors.highlightPrimary,
    brand: tenant.colors.contentBrand,
    addressText: tenant.colors.contentSecondary,
  },
};
